import { DiceValue } from './types';

export class DiceManager {
  private _value: DiceValue = 1;
  private _rolling: boolean = false;
  private _rollHistory: DiceValue[] = [];

  get value(): DiceValue { return this._value; }
  get rolling(): boolean { return this._rolling; }
  get rollHistory(): readonly DiceValue[] { return this._rollHistory; }

  roll(): Promise<DiceValue> {
    return new Promise((resolve) => {
      this._rolling = true;
      const rollTime = 400 + Math.random() * 400;
      const intervals = 8 + Math.floor(Math.random() * 8);

      let count = 0;
      const tick = () => {
        count++;
        this._value = (Math.floor(Math.random() * 6) + 1) as DiceValue;

        if (count >= intervals) {
          this._value = this.generateFairRoll();
          this._rolling = false;
          this._rollHistory.push(this._value);
          resolve(this._value);
          return;
        }

        const delay = rollTime / intervals * (0.5 + Math.random() * 0.5);
        setTimeout(tick, delay);
      };

      tick();
    });
  }

  private generateFairRoll(): DiceValue {
    const raw = Math.random();
    const biased = Math.floor(raw * 6);
    return (biased + 1) as DiceValue;
  }

  reset(): void {
    this._value = 1;
    this._rolling = false;
    this._rollHistory = [];
  }
}
